module.exports = __webpack_public_path__ + "static/img/1CreviewB7zLFxnfzyRFNOpPWCYqBO.0465b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/originalframerhtml_files/1CreviewB7zLFxnfzyRFNOpPWCYqBO.jpg
// module id = lXgC
// module chunks = 73